import { useState } from "react";

/*
 * Devolve o foco a quem abriu o diálogo, para o `onCloseAutoFocus` do Radix.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ O RADIX SÓ DEVOLVE O FOCO AO PRÓPRIO `Dialog.Trigger`.                   │
 * │                                                                          │
 * │ Nenhum diálogo do painel tem `Trigger`: quem abre é uma linha, um botão  │
 * │ de outra árvore ou a URL. Sem isto o foco cai no `body`, e quem opera    │
 * │ por teclado recomeça a tabulação do topo da tela a cada painel fechado.  │
 * │                                                                          │
 * │ A origem é lida no RENDER da abertura, e não em `onOpenAutoFocus`: o     │
 * │ `autoFocus` do primeiro campo acontece antes, e esse evento nem dispara  │
 * │ quando o foco já está dentro do diálogo.                                 │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * Elemento que saiu da tela não recebe foco: a linha pode ter sumido por causa da
 * própria ação.
 */
export function useDevolverFoco(aberto: boolean) {
  const [origem, setOrigem] = useState<Element | null>(null);
  const [estavaAberto, setEstavaAberto] = useState(false);

  if (aberto !== estavaAberto) {
    setEstavaAberto(aberto);
    if (aberto) setOrigem(document.activeElement);
  }

  return (evento: Event) => {
    if (!(origem instanceof HTMLElement) || !origem.isConnected) return;
    evento.preventDefault();
    origem.focus();
  };
}
